import { useEffect, useState } from "react";
import {
  submittedAnswerBarCodeData } from
"../../services/epic/bloodDonation";
import QuestionHeaders from "./QuestionHeaders";
import { Loader } from "../../common/Loader";
import formatMobileNumber from "../../common/FormatMobileNumber";

const QuestionStep6 = ({
  setRequestStep,
  mobileNum,
  submittedAnswerDataRequest,
  requestStep,
  loading,
  setLoading,
  handleCancel,
  userName,
  email,
  translationMap
}) => {
  const [isConsentChecked, setIsConstentChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const submitData = () => {
    if (!isConsentChecked) {
      setErrorMessage(
        translationMap?.mustAcknowledge ||
        "You must acknowledge the Informational Material before proceeding."
      );
      return;
    }
    let preStepAnswerQrCodeValue = "";
    if (submittedAnswerDataRequest) {
      preStepAnswerQrCodeValue = submittedAnswerDataRequest?.qrCodeValue;
    }
    let formattedNo = formatMobileNumber(mobileNum);
    let barCodeContent = "V1.0|" + formattedNo + "|" + preStepAnswerQrCodeValue;
    let userDetails = "NOT_A_LOGGED_IN_USER";
    const submitData = {
      barCodeAnswerResult: barCodeContent,
      loggedInUser: userDetails,
      mobileNumber: mobileNum,
      screenName: userName,
      email
    };
    submittedAnswerBarCodeData(submitData).then((result) => {
      if (result) {
        setRequestStep(8);
        window.parent.scrollTo(0, 0);
      }
    });
  };

  const handleBack = () => {
    setRequestStep(6);
    window.parent.scrollTo(0, 0);
  };

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
        <div className="container customContainer">
          <QuestionHeaders
            setRequestStep={setRequestStep}
            currentStep={requestStep - 1}
            translationMap={translationMap} />
          
          <div className="cover_inner_wrapper cover_inner_wrapper2">
            <div className="cover_main_box1">
              <div className="Optimized_Main_Wrap_Box Optimized_Main_Wrap_Box2">
                <div className="optimized_welcome_box">
                  <div className="donar_main_box">
                    <h6 className="Title_txt">
                      {translationMap?.dearDonor},&nbsp;
                    </h6>
                    <p className="para_txt">
                      {translationMap?.consent1}&nbsp;
                      {translationMap?.consent2}&nbsp;
                      {translationMap?.consent3}&nbsp;
                      {translationMap?.consent4}
                      {translationMap?.consent5 &&
                      <>&nbsp;{translationMap.consent5}</>
                      }
                    </p>
                  </div>
                  <div className="donar_main_box">
                    <h6 className="Title_txt">{translationMap?.consent}</h6>
                    <div className="custom_check_box custom_check_box2">
                      <input
                        type="checkbox"
                        className="checkboxField"
                        id="checkbox1"
                        onChange={(e) => setIsConstentChecked(e.target.checked)} />
                      
                      <label for="checkbox1">
                        {translationMap?.underSignedText}                      
                      </label>
                    </div>
                    {errorMessage &&
                    <span id="text" style={{ color: "#FF8F8A" }}>
                        {errorMessage}
                      </span>
                    }
                  </div>
                  <div className="optimized_btn_box optimized_btn_box_mrt">
                    <button onClick={submitData} className="bluetrans_btn_link">
                      {translationMap?.submit}
                    </button>
                    <button onClick={handleBack} className="bluetrans_btn_link">
                      {translationMap?.back}
                    </button>
                    <button
                      onClick={handleCancel}
                      className="Orangetrans_btn_link">
                      
                      {translationMap?.cancel}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="cover_main_box2"></div>
          </div>
        </div>
      </section>
    </>);

};

export default QuestionStep6;